import React, { useState, useEffect, useRef } from "react";
import Footer from "../Footer/Footer";
import NewHeader from "../NewHeader/NewHeader";
import { FaArrowLeft } from "react-icons/fa";
import BookForm from "../Plan-detail/BookForm";
import { Scroll } from "../Scroll function/scroll";
import { Link } from "react-router-dom";
import { BackToscreen } from "../New-Dashboard/Orders";
import { Warning, Regards } from "../Plan-detail/NewPlanComponent";
import { BsFillPlusCircleFill } from "react-icons/bs";
import { AiFillPlusCircle } from "react-icons/ai";
import { getCartDetails, getCouponCode, deleteMulitItemsCart, EmptyCart } from "../../Redux/Actions";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router";
import { connect } from "react-redux";
import "./Cart.css";
import metroCross from "../../Assets/metroCross.svg";
import Loader from "../Loader/Loader";
import PackageInfo from "./PackageInfo";
import { Modal } from "react-responsive-modal";
import 'react-responsive-modal/styles.css';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


export const FloatingButton = ({ amount }) => {
  return (
    <div className="mobileFooter">
      <p>
        Total Amount <br />
        <span style={{ fontWeight: "600" }}>Rs. {amount}/-</span>
      </p>
      <span className="add_tocart" style={{ borderRadius: "9px" }}>
        PROCEED
      </span>
    </div>
  );
};

export const AddMore = (citySelect) => {
  const history = useHistory();
  return (
    <div
      className=" vflex"
      onClick={() =>
        history.push(
          `/health-checkup-packages${citySelect.citySelect != '' ? `-${citySelect.citySelect.toLowerCase().replace(" ", "-")}` : ''}`
        )
      }
    >
      <h5 className="note">Add More Test</h5>

      <AiFillPlusCircle />
    </div>
  );
};

export const BackToscreenIcon = ({ title, currpath }) => {
  return (
    <div className="currentWindow">
      <Link to={`/${currpath}`}>
        {/* <FaArrowLeft /> */}
        {title}
      </Link>
    </div>
  );
};

export const DesktopBack = ({ title, currpath }) => {
  return (
    <div className="backIcon">
      <Link to={`/${currpath}`}>
        {/* <FaArrowLeft /> */}
        {title}  
      </Link>
    </div>
  );
};



function Cart(props) {
  const history = useHistory();
  const [cartEMpty, setCartEmpty] = useState(true);
  const dispatch = useDispatch();
  const [removeAllPackageModal, setRemoveAllPackageModal] = useState(false)
  const location = useLocation();


  const citySelected = useSelector((state) => state.cityOnTopNav);
  const { loading: loadingCity, citySelect } = citySelected;
  const currentcity = citySelected.citySelect;

  const [openMDPackage, setOpenMDPackage] = useState(false);
  const onCloseMDPackage = () => setOpenMDPackage(false);


  const cartDetails = useSelector((state) => state.CartReducer);

  useEffect(() => {
    const userFromLocal = JSON.parse(localStorage.getItem("user"));
    var token = userFromLocal && userFromLocal.token;

    if (token) {
      dispatch(getCartDetails(token, currentcity));
      dispatch(getCouponCode(token));
    } else {
      dispatch(getCartDetails(currentcity));
      dispatch(getCouponCode());
      history.push({
        pathname: `/login`,
        pushToUrl: "cart",
      });
    }
  }, [currentcity]);

  const [notAvailPackage, setnotAvailPackage] = useState([]);
  const [priceChangePackage, setpriceChangePackage] = useState([]);
  const [localsCity, setLLocalSCity] = useState("");


  console.log("cart details", cartDetails);
  const { loading, cartDetails: cartdata } = cartDetails;

  if (loading == false && cartDetails.cartDetails != undefined && localsCity == currentcity) {
    console.log(localsCity, currentcity, 'localsCity and currentcity')
    let packlist = cartDetails &&
      cartDetails.cartDetails &&
      cartDetails.cartDetails[0] && cartDetails.cartDetails[0].product;
    localStorage.setItem('cartItem', JSON.stringify({ 'cartItem': packlist, 'city': currentcity }))
  }

  useEffect(() => {
    const userFromLocal = JSON.parse(localStorage.getItem("user"));
    var token = userFromLocal && userFromLocal?.token;
    cartDetails?.cartDetails && cartDetails?.cartDetails[0]?.product?.forEach(item => {
      if (item?.package?.org_type == "imaging") {
        setRemoveAllPackageModal(true)
        props.EmptyCart(token)
        setTimeout(() => {
          props.getCart(token)
        }, 500);
        return
      }
    })
  }, [])


  useEffect(() => {
    const localCity = localStorage.getItem('city');
    const localCartDetail = JSON.parse(localStorage.getItem('cartItem'));
    if (localCity != null && localsCity == "") {
      setLLocalSCity(localCity)
    }
    if (localsCity != currentcity && loading == false && cartDetails.cartDetails != undefined && cartDetails.cartDetails &&
      cartDetails.cartDetails[0] && cartDetails.cartDetails[0].product) {
      cartDetails.cartDetails[0].product.forEach((item1, key1) => {
        localCartDetail?.cartItem?.forEach((item2, key2) => {
          if (item1.package.id == item2.package.id) {
            if (item1.package.package_city_prices != null && item2.package.package_city_prices == null) {
              const priceDef = item1.package.package_city_prices.offer_price;
              const priceOldCity = item2.package.offer_price;
              if (priceDef != priceOldCity && cartDetails &&
                cartDetails.cartDetails &&
                cartDetails.cartDetails[0] && cartDetails.cartDetails[0].product) {
                cartDetails.cartDetails[0].product[key1].package.price_deference = Math.abs(priceDef)
                cartDetails.cartDetails[0].product[key1].package.price_old_city = Math.abs(priceOldCity)
                const filterIndex = cartDetails.cartDetails[0].product.filter(
                  item => item.package.id === item1.package.id
                )
                setpriceChangePackage(filterIndex);
              }
            } else if (item2.package.package_city_prices != null && item1.package.package_city_prices == null) {
              const priceDef = item1.package.offer_price;
              const priceOldCity = item2.package.package_city_prices.offer_price;
              if (priceDef != priceOldCity && cartDetails &&
                cartDetails.cartDetails &&
                cartDetails.cartDetails[0] && cartDetails.cartDetails[0].product) {
                cartDetails.cartDetails[0].product[key1].package.price_deference = Math.abs(priceDef)
                cartDetails.cartDetails[0].product[key1].package.price_old_city = Math.abs(priceOldCity)
                const filterIndex = cartDetails.cartDetails[0].product.filter(
                  item => item.package.id === item1.package.id
                )
                setpriceChangePackage(filterIndex);
              }
            } else if (item2.package.package_city_prices != null && item1.package.package_city_prices != null) {
              const priceDef = item1.package.package_city_prices.offer_price;
              const priceOldCity = item2.package.package_city_prices.offer_price;
              if (priceDef != priceOldCity) {
                cartDetails.cartDetails[0].product[key1].package.price_deference = Math.abs(priceDef);
                cartDetails.cartDetails[0].product[key1].package.price_old_city = Math.abs(priceOldCity);
                const filterIndex = cartDetails.cartDetails[0].product.filter(
                  item => item.package.id == item1.package.id
                )
                setpriceChangePackage(filterIndex);
              }
            } else {
              const priceDef = item2.package.offer_price - item1.package.offer_price;
              cartDetails.cartDetails[0].product[key1].package.price_deference = Math.abs(priceDef)
              cartDetails.cartDetails[0].product[key1].package.price_old_city = Math.abs(0)
            }
          }
        })
      })
    } else {
      setpriceChangePackage([])
    }
  }, [cartDetails]);

  useEffect(() => {
    if (loading == false && cartDetails.cartDetails != undefined) {
      if (cartDetails.cartDetails.length > 0) {
        let packlist = cartDetails.cartDetails[0].product;
        const notava = cartDetails.cartDetails[0].product.filter(
          item => item.package.available === false
        )
        setnotAvailPackage(notava)
      }
    }
  }, [cartDetails, currentcity]);

  toast.configure()
  const successCb = () => {
    console.log('delete suceess')
    const userFromLocal = JSON.parse(localStorage.getItem("user"));
    var token = userFromLocal.token;
    dispatch(getCartDetails(token, citySelect && citySelect));
    toast.success('Item(s) is successfully removed from the cart.', { position: toast.POSITION.BOTTOM_CENTER, bodyClassName: 'singleItemsss', });
  };

  const closeMDPModal = (notAvailPackage) => {
    const userFromLocal = JSON.parse(localStorage.getItem("user"));
    var token = userFromLocal.token;
    let cardId = notAvailPackage.map(item => item.id).join(',');
    dispatch(deleteMulitItemsCart(token, cardId, successCb));
    setOpenMDPackage(false)
  }
  const deleteMPackage = () => {
    setOpenMDPackage(true)
  }

  const BackToHomeNew = () => {
    setRemoveAllPackageModal(false);
    // history.push("/");
    window.location.href = process.env.RAZZLE_APP_BASE_URL
  };
 

  return (
    <>
      <NewHeader />

      <BackToscreenIcon title="My Cart" currpath="cart" />
      <div className="container">
        <DesktopBack title="My Cart" currpath="cart" />
      </div>

      <div className="cart">
        {/** SHOW THIS DIV IF CART IS EMPTY */}
        {loading ? (
          <Loader />
        ) : cartDetails &&
          cartDetails.cartDetails &&
          cartDetails.cartDetails[0] &&
          cartDetails.cartDetails[0].product.length > 0 ? (
          /** SHOW THIS DIV IF CART IS NOT EMPTY */

          <div className="cart_main">
            {console.log("cart array", cartDetails.cartDetails[0].product)}
            <div className="cart_leftSide">
              {notAvailPackage.length > 0 || priceChangePackage.length > 0 ?
                <div className="UpdatesCarts">
                  <h5>Updates in your cart</h5>
                </div>
                : null}
              {notAvailPackage.length > 0 || priceChangePackage.length > 0 ?
                <div className="UpdatesPackageCarts">
                  {priceChangePackage.length > 0 ?
                    <div className="notAvailableItem">
                      <ul>
                        {priceChangePackage.length > 0 && priceChangePackage.map((value) =>
                          <li>The price for <strong>{value?.package?.name}</strong> has been updated from <strong>Rs. {value.package.price_old_city} to Rs. {value.package.price_deference}</strong></li>
                        )}
                      </ul>
                    </div>
                    : null}
                  {notAvailPackage.length > 0 ?
                    <div className="notAvailableItem">
                      <ul>
                        <li>{notAvailPackage && notAvailPackage.length > 0 ? notAvailPackage.length : 0} item(s) in your cart is not available for selected city</li>
                      </ul>
                    </div>
                    : null}
                  {notAvailPackage.length > 0 ?
                    <div className="UnavailableItem">
                      <button onClick={() => deleteMPackage()} disabled={notAvailPackage.length == 0}>View Items</button>
                    </div>
                    : null}
                </div>
                : null}
              <div className="UpdatesCarts">
                <h4>Items In your cart</h4><span>Total - ({cartDetails.cartDetails[0].product.length})</span>
              </div>
              {/* <div className="box paddng_2">
                <span>Selected </span>
                <span>
                  Redcliffe labs Diagnostics Pvt. Ltd. Noida Sector-62
                </span>
              </div>{" "}
              */}
              {/* *Package info component */}
              {cartDetails &&
                cartDetails.cartDetails &&
                cartDetails.cartDetails[0] &&
                cartDetails.cartDetails[0].product.length > 0 &&
                cartDetails.cartDetails[0].product.map((values) => {
                  return <PackageInfo key={values.id} cartData={values} notavailPack={notAvailPackage} />;
                })}

              {/***Add more div */}
              <AddMore citySelect={citySelect} />
              {/* <Warning desc="Do not eat or drink anything (except water) 8-10 hours before test" /> */}
              <Regards />
            </div>
            <div className="cart_RightSide">
              <BookForm
                empty={false}
                details={cartDetails &&
                  cartDetails.cartDetails &&
                  cartDetails.cartDetails[0] && cartDetails.cartDetails[0].product}
                notavailPack={notAvailPackage}
                setOpenMDPackage={setOpenMDPackage}
              />
            </div>

            {/**MOBILE FOOTER */}
          </div>
        ) : (
          <div className="cartDiv">
            <img
              src="https://staticcdn.redcliffelabs.com/media/gallary-file/None/dc2c4338-9b68-4b36-9c43-2969dca2665a.svg"
              alt="cart_img"
              width="100%"
            />
            <div className="cartDesc">
              <h2 className="cartHeading">Your Cart is Empty! { }</h2>
              <p className="font_2rem cartmsg">
                There are no items in your cart. Explore and add packages!
              </p>
              <Link
                to={`/health-checkup-packages${citySelect ? `-${citySelect
                  .toLowerCase()
                  .replace(" ", "-")}` : ''}`}
              >
                <span className="exploreBtn">EXPLORE PACKAGES</span>
              </Link>
            </div>
          </div>
        )}
      </div>
      <Modal open={openMDPackage} onClose={onCloseMDPackage} center classNames={{
        modal: 'MDeletePackageModal',
      }}
      >
        <p className="modalTitle">{notAvailPackage && notAvailPackage.length > 0 ? notAvailPackage.length : 0} item(s) not available</p>
        <hr className="topHr" />
        <div className="packageAddToCart">
          {notAvailPackage && notAvailPackage.length > 0
            ? notAvailPackage.map((value) => {
              return (
                <>
                  <h4>{value.package.name}</h4>
                  <p>Package not available for {currentcity ? currentcity : 'city'}</p>
                </>
              )
            }) : null}
        </div>
        <hr className="bottomHr" />
        <div className="cartButtons">
          <button className="closeModal" onClick={() => closeMDPModal(notAvailPackage)}>Remove Unavailable Item(s)</button>
        </div>
      </Modal>
      <Modal
        open={removeAllPackageModal}
        onClose={()=>{setRemoveAllPackageModal(false)}}
        center
        classNames={{
          overlay: "customFooterOverlay",
          modal: "customFooterModal",
        }}
      >
        <div onClick={()=>{setRemoveAllPackageModal(false)}} className="modalCloseButton" >
          <img className="crossButton" src={metroCross} alt="" />
        </div>
        <div className="footer-modal">
          <h2>Your cart has been cleared.</h2>
          <h2>Both Pathology and Radiology package's can not be added in a single cart</h2>
          <div className="modal-inner">
             {/* <a href={process.env.RAZZLE_APP_BASE_URL} className="modal-link" onClick={onCloseModal}>
              No
            </a> */}
            <button className="modal-link" onClick={BackToHomeNew}>
              OK{" "}
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
}

const mapStateToProps = (state) => ({
  AddonState: state?.AddonSetter?.Addon,
});

const mapDispatchToProps = (dispatch) => {
  return {
    EmptyCart: (token) => {
      dispatch(EmptyCart(token));
    },
    getCart: (token) => {
      dispatch(getCartDetails(token));
    },
  };
};

export default {
  component: connect(mapStateToProps, mapDispatchToProps)(React.memo(Cart)),
};
